import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_ELEVATION = 'data-0';

export default function MUITableContainer(theme: Theme) /* : Components['MuiTableContainer'] */ {
  return {
    // defaultProps: {},
    styleOverrides: {
      root: {
        overflow: 'hidden',
        boxShadow: theme.shadows[3],
        borderRadius: theme.shape.borderRadius,
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },
    variants: [
      ...theme.shadows.map((boxShadow, index) => ({
        props: { [CUSTOM_ATTRIBUTE_ELEVATION]: index },
        style: {
          boxShadow,
        },
      })),
    ],
  };
}
